import { Modal } from '@shared/ui/Modal'
import { Button } from '@shared/ui/Button'
import { useTelegramLinkPolling } from '../model/useLinkTelegramPolling'
import styles from './LinkTelegramWaitModal.module.css'

interface LinkTelegramWaitModalProps {
  /** Колбэк закрытия (вызывается также при успешной связке) */
  onClose: () => void
}

/**
 * Модалка ожидания подтверждения связки Telegram из web-версии.
 * Поллит профиль и закрывается автоматически, когда telegram привязан.
 * @param onClose - Колбэк закрытия
 */
export const LinkTelegramWaitModal = ({ onClose }: LinkTelegramWaitModalProps) => {
  useTelegramLinkPolling(true, () => {
    onClose()
  })

  return (
    <Modal onClose={onClose}>
      <div className={styles.panel}>
        <h3 className={styles.title}>Ждём подтверждения от Telegram…</h3>
        <p className={styles.text}>
          Подтвердите связку в открывшемся окне Telegram. Это окно обновится автоматически.
        </p>
        <Button variant="secondary" onClick={onClose} block>Закрыть</Button>
      </div>
    </Modal>
  )
}
